var _desc, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "71px",
    viewBox: "0 0 102 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Counter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Counter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COUNTER",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0313889,6.22709302 C33.8338194,6.98767442 -1.82048611,2.58639535 0.272222222,40.4172093 C2.88555556,56.2416279 14.7170139,63.0868605 28.7704861,65.6497674 C44.3994444,68.4830233 62.4307639,66.7311628 74.6365278,65.8083721 C94.0323611,62.812907 103.624792,37.5262791 94.2739583,20.2924419 C86.4918056,8.94139535 71.4583333,6.57313953 59.0313889,6.22709302 Z",
    id: "SHADOW",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0313889,0.227093023 C33.8338194,0.987674419 -1.82048611,-3.41360465 0.272222222,34.4172093 C2.88555556,50.2416279 14.7170139,57.0868605 28.7704861,59.6497674 C44.3994444,62.4830233 62.4307639,60.7311628 74.6365278,59.8083721 C94.0323611,56.812907 103.624792,31.5262791 94.2739583,14.2924419 C86.4918056,2.94139535 71.4583333,0.573139535 59.0313889,0.227093023 Z",
    id: "STROKE_99fb390a-b112-4495-90fb-e96524237ba6",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#7BA5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5,13.2945668 C81.858724,10.3581321 73.2398814,8.45347031 58.6434722,7.5805814 C44.9166667,7.20930233 30.594375,7.71755814 17.3541667,11.7475581 C10.4022917,14.5267442 7.63243056,22.0063953 7.14583333,28.0333721 C7.46149553,34.9326603 8.52211246,39.0478384 10.3276841,40.3789062",
    id: "Path",
    stroke: "#96C2D3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0360417,44.2182558 C20.7569444,51.0094186 30.4752778,53.3488372 40.4624306,53.3488372 C60.2291667,53.3272093 87.1995833,57.1445349 92.2323705,31.2162791 C92.2141756,25.6634756 91.1754557,21.2883227 89.1162109,18.0908203",
    id: "Path",
    stroke: "#5C90A3",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.ecaed282f2aedfc39a473d980fd9f529.svg";
export { ForwardRef as ReactComponent };